module.exports = __webpack_public_path__ + "static/img/4.307e657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Responsabilidad-civil-danos-terceros/4.png
// module id = 4/Yl
// module chunks = 0